import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { c } from '@debbie/cortex/dist/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Header, Input } from '../../index.js';
const PasswordCreator = (props) => {
    const lang = useSelector((s) => s.lang);
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const valid = password.length >= 8;
    const createPassword = useMutation(() => c.auth.createPassword(props.token, password), {
        onSuccess: (response) => {
            if (response != null) {
                const queryParams = new URLSearchParams(window.location.search);
                queryParams.delete('nu_token');
                window.location.search = queryParams.toString();
            }
        },
        onError: (err) => {
            console.error(err);
            setError(err?.message);
        },
    });
    return (React.createElement("div", null,
        React.createElement("form", { onSubmit: (e) => {
                e.preventDefault();
                e.stopPropagation();
                setError('');
                createPassword.mutate();
            } },
            React.createElement(Header, null, lang.onboarding.welcome),
            React.createElement("p", null, lang.onboarding.passwordCreatorExplainer),
            error !== '' ? React.createElement("div", { className: "warning" }, error) : null,
            React.createElement(Input, { type: "password", placeholder: lang.login.password, onChange: (e) => {
                    setPassword(e.target.value);
                }, value: password }),
            React.createElement(Button, { block: true, style: { marginBottom: '10px' }, disabled: !valid, loading: createPassword.isLoading }, lang.misc.submit))));
};
export default PasswordCreator;
//# sourceMappingURL=PasswordCreator.js.map